export default "__VITE_ASSET__DftoUQPu__"